import { render, staticRenderFns } from "./PlatformDeploymentStatus.vue?vue&type=template&id=2a34cfac"
import script from "./PlatformDeploymentStatus.vue?vue&type=script&lang=js"
export * from "./PlatformDeploymentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports